import React from 'react'
import Layout from './layout-tank/layout'
import CardGroup from './card-group/card-group'
import { MENU_ITEMS_TANK } from './dummies/menuItems'

const TankHome = () => (
  <Layout>
    <div style={{ height: '90vh' }}>
      <CardGroup items={MENU_ITEMS_TANK} />
    </div>
  </Layout>
)

export default TankHome
